module.exports = __webpack_public_path__ + "img/ctrl-pauli-root-stub-down--.a199a8f3.svg";